import { render, staticRenderFns } from "./PER.vue?vue&type=template&id=6554a62d&scoped=true&"
import script from "./PER.vue?vue&type=script&lang=js&"
export * from "./PER.vue?vue&type=script&lang=js&"
import style0 from "./PER.vue?vue&type=style&index=0&id=6554a62d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6554a62d",
  null
  
)

export default component.exports